module.exports = __webpack_public_path__ + "img/Sound Decision Maker.168e1d3a.svg";